import { Injectable, inject } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToasterService } from '../../shared/toaster/toaster.service';
import { SUPPRESS_GLOBAL_ERROR_TOAST } from '../constants/http-context.tokens';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { Shared } from '../services/shared';
import { clientToken, logoutRedirect, tokenSignal } from '../constants/auth-state';

@Injectable()
export class ToastInterceptor implements HttpInterceptor {
  private readonly toaster = inject(ToasterService);
  private readonly shared = inject(Shared);
  private readonly router = inject(Router);
  private readonly dialog = inject(MatDialog);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse) => {

        if (req.context.get(SUPPRESS_GLOBAL_ERROR_TOAST)) {
          return throwError(() => err);
        }

        let message: string | null = null;

        // ✅ 1. No Internet / Network Error
        if (err.status === 0) {
          message = 'No internet connection. Please check your network.';
        }

        // ✅ 2. Backend validation errors (your custom structure)
        else if (err?.error?.errorMessages?.length) {
          message = err.error.errorMessages.join(', ');
        }

        // ✅ 3. Unauthorized
        else if (err.status === 401) {
          message = 'Session expired. Please login again.';
          if ((tokenSignal() || clientToken()) && !this.isPreferenceFormInitialLoad(req)) {
            logoutRedirect(this.shared, this.router, this.dialog);
          }
        }

        // ✅ 4. Forbidden
        else if (err.status === 403) {
          message = 'You do not have permission to perform this action.';
        }

        else if (err.status === 404) {
          message = 'Requested resource not found. Contact Admin.';
        }

        // ✅ 5. Server Error
        else if (err.status >= 500) {
          message = 'Server error occurred. Please try again later.';
        }

        // ✅ 6. Fallback generic message
        else {
          message = err?.message || 'Something went wrong. Please try again.';
        }

        // Show toast
        this.toaster.show({
          message:message ? message : 'An error occurred. Please try again.',
          status: 'error',
          showClose: true,
          timeout: 3000
        });

        return throwError(() => err);
      })
    );
  }

  private isPreferenceFormInitialLoad(req: HttpRequest<any>): boolean {
    return req.url.includes('/PreferenceForm/contact-preferenceform/')
      || req.url.includes('/Prospect/contact-preferenceform/');
  }
}
